import BaseClient from '@/app/model/api/response/baseApiClient'

class MypagePasswordApi extends BaseClient {
  public doMypagePasswordResetting (bodyData: {[key: string]: string}) {
    const path = '/v1/setting/user/password'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new MypagePasswordApi()
